
import { AUDIO_ASSET_TYPE, VIDEO_ASSET_TYPE, IMAGE_ASSET_TYPE } from 'model/const';

export const defaultImage = {
    url: null,
    size: { width: null, height: null },
    type: IMAGE_ASSET_TYPE
}


export const imageElementInitialData = {
    rendition: {
        base: {
            url: null,
            size: { width: null, height: null },
            type: IMAGE_ASSET_TYPE
        },
        defaultImage,
        variants: {}
    }
}


export const videoElementInitialData = {
    rendition: {
        base: {
            url: null,
            size: { width: null, height: null },
            type: VIDEO_ASSET_TYPE
        },
        defaultImage,
        variants: {}
    }
}


export const audioElementInitialData = {
    rendition: {
        base: {
            url: null,
            type: AUDIO_ASSET_TYPE
        },
        defaultImage,
        variants: {}
    }
}
